import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DsIconComponent } from './components/icon/icon.component';
import { SkyMiscModule } from '@skyeng/libs/shared/misc';
import { generatedIcons } from './components/generated-icons';
import { DsIconConfig } from './icon.config';

@NgModule({
  imports: [CommonModule, SkyMiscModule],
  declarations: [DsIconComponent, ...generatedIcons],
  exports: [DsIconComponent, ...generatedIcons],
})
export class DsIconModule {
  static forRoot(config: DsIconConfig): ModuleWithProviders<DsIconModule> {
    return {
      ngModule: DsIconModule,
      providers: [{ provide: DsIconConfig, useValue: config }],
    };
  }
}
